import { ClosingScreen } from './ClosingScreen';

export default function ClosingScreenEntry(): JSX.Element {
  return <ClosingScreen />;
}
